import i18n from '@/i18n'
import { mapActions } from 'vuex'
import Vue from 'vue'
import { EventHub } from "@/constants/constants"
import { DialogRuses } from '@/tools/dialog'
import { mapGetters } from "vuex"
import RusConfigurationTabComponent from './rus-configuration/RusConfigurationTabComponent.vue'
import { clone } from 'ramda'

export default {
    name: 'RusConfigurationDialogComponent',
    components: {
        RusConfigurationTabComponent
    },
    props: {
        // v-model injects the object to be edited into props.value
        model: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        // reglas de validación
        validationRules: {
            required: (value) => !!value || value === 0 || `${i18n.t('required')}`,
            noDuplicateProperty: (allValues, value) => !(allValues.filter(v => v === value).length > 1) || `${i18n.t('error.duplicateProperty')}`
        },
        // flag para resetear validaciones en los formularios
        resetForms: false,
        // indica si se está actualizando una empresa
        update: false,
        // componente con tabla editable de configuración
        configurationComponent: {
            content: {
                _uid: 'SDTtsTA1iw',
                component: 'RusConfigurationTabComponent',
                headline: 'RusConfigurationTabComponent'
            },
            model: {},
            validForm: false
        },
    }),
    computed: {
        ...mapGetters({
            'getBread': 'breadcrumbs/getBread',
        }),
        validRuses () {
            if (this.configurationComponent.model.rusConfigurations) {
                let valid = true;
                Object.values(this.configurationComponent.model.rusConfigurations).forEach(rusConfiguration => {
                    const allValues = rusConfiguration.map(c => c.property);
                    rusConfiguration.forEach( config => {
                        if (!config.property) {
                            valid = false;
                            return;
                        }
                        if (allValues.filter(v => v === config.property).length > 1) {
                            valid = false;
                            return;
                        }
                    });
                    if (!valid) return;
                })
                return valid;
            }
            return true;
        }
    },
    created () {
        /**
         * El modelo de datos del diálogo se carga a través del objeto del breadcrumb
         */
        this.unwatch = this.$store.watch(
        (state, getters) => getters['breadcrumbs/getBread'],
            (newBreads) => {
                const lastBreadcrumb = this.getBread[newBreads.length - 1]
                if (!lastBreadcrumb) {
                    this.cancel()
                } else {
                    if (lastBreadcrumb.key === DialogRuses) {
                        if (lastBreadcrumb.model) {
                            const modelData = this.model
                            Object.assign(modelData, lastBreadcrumb.model)
                        }
                        this.configurationComponent.model = clone(this.model)
                        this.update = lastBreadcrumb.update
                    }
                }
            },
        { deep: true })
    },
    mounted () {
        const lastBreadcrumb = this.getBread[this.getBread.length - 1]
        if (!lastBreadcrumb) {
            this.cancel()
        } else {
            if (lastBreadcrumb.key === DialogRuses) {
                if (lastBreadcrumb.model) {
                    const modelData = this.model
                    Object.assign(modelData, lastBreadcrumb.model)
                }
                this.configurationComponent.model = clone(this.model)
                this.update = lastBreadcrumb.update
            }
        }
    },
    beforeDestroy () {
        // elimino la instancia del watcher del breadcrumb
        this.unwatch()
    },
    methods: {
        /**
         * actions del snackbar
         */
        ...mapActions('snackbar', [
            'showSnackbar',
            'closeSnackbar'
        ]),
        /**
         * actions del dialog
         */
        ...mapActions('dialog', [
            'openDialog',
            'closeDialog'
        ]),
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pullBread'
        ]),
        /**
         * Resetea los campos del formulario de creación/actualización
         */
        resetFields() {
            this.configurationComponent.model = {}

            // para limpiar las validaciones en los formularios
            this.resetForms = true
            const that = this
            Vue.nextTick(function() {
                that.resetForms = false
            })
        },
        /**
         * Click fuera del dialog
         */
        clickOutside() {
            this.cancel()
        },
        /**
         * Cancelar
         */
        cancel() {
            this.pullBread(DialogRuses)
            this.resetFields()
        },
        /**
         * Guardar
         */
        save() {
            const rusConfiguration = this.getRusConfiguration()
            this.cancel()
            this.$eventBus.$emit(EventHub.COMMIT_RUS_CONFIGURATION, rusConfiguration)
        },
        /**
         * Genera el objeto que se guarda en la empresa
         */
        getRusConfiguration() {
            Object.keys(this.configurationComponent.model.rusConfigurations).forEach(rus => {
                if (this.configurationComponent.model.rusConfigurations[rus].length <= 0) {
                    delete this.configurationComponent.model.rusConfigurations[rus]
                }
                else {
                    // Se eliminan las propiedas con valor == "", null o undefined
                    this.configurationComponent.model.rusConfigurations[rus].forEach(el => {
                        if(!el.adjustment) 
                            delete el.adjustment;
                        if(!el.unit) 
                            delete el.unit;
                        if(!el.mapTo) 
                            delete el.mapTo;
                    })
                }
            })
            return { 
                typeId: this.model.typeId,
                rusConfigurations: Object.keys(this.configurationComponent.model.rusConfigurations).length === 0 ? undefined : this.configurationComponent.model.rusConfigurations
            }
        },
        /**
         * Retorna un boolean para habilitar / deshabilitar el botón save
         */
        disableSaveBtn () {
            return !this.configurationComponent.validForm || !this.validRuses
        }
    },
    watch: {
        model: {
            deep: true,
            immediate: true,
            handler: function (newModel) {
                if (newModel) {
                    this.configurationComponent.model = clone(newModel)
                }
            }
        }
    }
}
